'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _consignment = require('./remote/consignment');

var Consignment = {
    postConsignment: function postConsignment(params) {
        return _consignment.ConsignmentRemote.postConsignment(params);
    }
};

exports.default = Consignment;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/consignment.js
// module id = /rMq
// module chunks = 46